const SIZE_FIELDS = [
  'availableSmallDoors',
  'availableMediumDoors',
  'availableLargeDoors',
  'availableXLargeDoors',
];

/**
 * Puertas disponibles de un locker, o `null` si el payload no lo dice.
 *
 * El API expone el agregado `availableDoors`, pero no todos los endpoints lo
 * traen; cuando falta se reconstruye sumando el desglose por tamaño. Si no hay
 * ni agregado ni desglose devuelve `null` y no 0: son cosas distintas —cero
 * disponibles significa locker lleno— y confundirlas pintaba al 100% un locker
 * cuyo único problema era venir incompleto.
 */
export const getAvailableDoors = (platform) => {
  if (platform?.availableDoors != null) return Number(platform.availableDoors);

  const present = SIZE_FIELDS.filter((field) => platform?.[field] != null);
  if (present.length === 0) return null;

  return present.reduce((sum, field) => sum + Number(platform[field]), 0);
};

/**
 * Porcentaje de ocupación de un locker, entero de 0 a 100.
 *
 * Se calcula como el complemento de las puertas disponibles —lo que no está
 * disponible— y no sobre las ocupadas, porque el total que devuelve el API es
 * Ocupied + Reserved + Available + Inactive: ocupadas/total y disponibles/total
 * no suman 100, y la fila mostraba «50%» al lado de «28/58» sin que cuadraran.
 *
 * Contrapartida asumida: una puerta reservada o inactiva sube el porcentaje
 * aunque esté vacía. A cambio, los dos números de la fila son coherentes
 * siempre, sin depender de cómo el API reparta reservadas e inactivas.
 */
export const getOcupationPercentage = (totalDoors, availableDoors) => {
  const total = Number(totalDoors);
  if (!Number.isFinite(total) || total <= 0) return 0;

  const available = Number(availableDoors);
  if (!Number.isFinite(available)) return 0;

  return Math.min(Math.max(Math.round(((total - available) / total) * 100), 0), 100);
};
